import { render, staticRenderFns } from "./fontIcon.vue?vue&type=template&id=5bcb302c"
import script from "./fontIcon.vue?vue&type=script&lang=js"
export * from "./fontIcon.vue?vue&type=script&lang=js"
import style0 from "./fontIcon.vue?vue&type=style&index=0&id=5bcb302c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports